import { createSelector } from '@reduxjs/toolkit';

import { IState } from '../../store';

const selectRosreestrState = (state: IState) => state.rosreestr;

export const selectRosreestrItems = createSelector([selectRosreestrState], rosreestr => {
  if (!rosreestr) {
    return [];
  }

  return rosreestr.items;
});
